import { Link, useLocation } from "react-router-dom";

export function Header() {
  const location = useLocation();
  const isEditor = location.pathname !== "/" && location.pathname.length > 1;

  if (isEditor) {
    return (
      <header className="w-full bg-white border-b border-gray-200 px-4 py-2 flex items-center justify-between">
        <Link to="/" className="text-xl font-bold tracking-tight text-gray-800">
          hogmoji.fun
        </Link>
        <Link
          to="/"
          className="p-2 text-gray-500 hover:text-gray-800 hover:bg-gray-100 rounded-full transition-colors"
          title="Close"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </Link>
      </header>
    );
  }

  return (
    <nav className="w-full bg-gray-100">
      <div className="container mx-auto py-4 flex flex-col md:flex-row justify-between items-center">
        <Link to="/" className="mb-4 md:mb-0 text-center md:text-left">
          <h1 className="text-3xl font-bold tracking-tight text-gray-800">
            hogmoji.fun
          </h1>
          <p className="text-gray-500 text-sm font-medium">Build your own PostHog hedgehog emoji</p>
        </Link>
        <div className="flex items-center space-x-6">
          <a
            className="flex items-center gap-2 text-gray-600 hover:text-hog-500 font-medium transition-colors"
            href="https://github.com/PostHog/hogmoji.fun"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span>GitHub</span>
            <svg
              aria-hidden="true"
              className="w-5 h-5"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                clipRule="evenodd"
                d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z"
                fillRule="evenodd"
              />
            </svg>
          </a>
        </div>
      </div>
    </nav>
  );
}
